module.exports = __webpack_public_path__ + "static/media/mooring.2f6d946f.svg";